import React, { useState, useContext } from 'react';
import emailjs from 'emailjs-com';
import { ShopContext } from '../context/ShopContext'; // Adjust import as needed

const GenerateToken = () => {
  const { userData } = useContext(ShopContext);
  const [showPopup, setShowPopup] = useState(false);
  const [query, setQuery] = useState('');
  const [message, setMessage] = useState('');

  const handleOpenPopup = () => {
    if (!userData?.email) {
      setMessage('Please log in first to submit a query.');
      return;
    }
    setShowPopup(true);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
    setQuery('');
    setMessage('');
  };

  const handleSubmitQuery = (e) => {
    e.preventDefault();

    if (!query.trim()) {
      setMessage('Please enter your query before submitting.');
      return;
    }

    const emailDataAdmin = {
      user_email: userData.email,
      user_query: query,
    };

    const emailDataUser = {
      user_email: userData.email,
      message: `Your query has been received. Our team will get back to you soon. \n\nQuery: ${query}`,
    };

    // Send email to Admin
    emailjs.send('service_usjd53g', 'template_9aey5ji', emailDataAdmin, '1QTyWl9bCO8phmxy1')
      .then(() => {
        // Send confirmation email to User
        emailjs.send('service_usjd53g', 'template_user_confirm', emailDataUser, '1QTyWl9bCO8phmxy1')
          .then(() => {
            setMessage('Token Generated Successfully. Check your email.');
            handleClosePopup();
          })
          .catch(() => {
            setMessage('Token Generated, but confirmation email failed.');
          });
      })
      .catch(() => {
        setMessage('Something went wrong, please try again.');
      });
  };

  return (
    <div className="text-center mt-6 ">
      {!userData?.email ? (
        <p className="text-red-600">You need to log in first.</p>
      ) : (
        <button
          onClick={handleOpenPopup}
          className="bg-[#FF4902] text-white py-2 px-4 rounded-lg shadow-md hover:bg-opacity-80 transition duration-200"
        >
          Submit a Query
        </button>
      )}

      {showPopup && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-96 relative z-50">
            <button
              onClick={handleClosePopup}
              className="absolute top-2 right-2 text-gray-600 hover:text-red-600 text-lg"
            >
              ✖
            </button>
            <h2 className="text-xl font-bold mb-4">Generate Token</h2>
            <textarea
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Enter your query..."
              className="border border-gray-300 p-2 w-full rounded-lg h-24"
            />
            <button
              onClick={handleSubmitQuery}
              className="mt-4 bg-[#FF4902] text-white py-2 px-4 rounded-lg w-full hover:bg-opacity-80 transition duration-200"
            >
              Generate Token
            </button>
          </div>
        </div>
      )}

      {message && <p className="mt-4 text-gray-700">{message}</p>}
    </div>
  );
};

export default GenerateToken;
